(function(window) {
  "use strict";
  if (window.AuxitoUtils) return;

  function readJson(storage, key) {
    try {
      var raw = storage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function writeJson(storage, key, value) {
    try {
      storage.setItem(key, JSON.stringify(value));
    } catch (e) {}
  }

  function shouldRetry(status) {
    return status === 408 || status === 425 || status === 429 || status >= 500;
  }

  async function fetchWithRetry(url, options, retries) {
    var maxRetries = retries == null ? 2 : Number(retries);
    var delay = 200;
    var attempt = 0;
    var lastError = null;
    while (attempt <= maxRetries) {
      try {
        var response = await fetch(url, options);
        if (response.ok) return response;
        if (!shouldRetry(response.status) || attempt >= maxRetries) {
          throw new Error("Fetch failed " + url + ": " + response.status);
        }
        lastError = new Error("Retryable " + url + ": " + response.status);
      } catch (error) {
        if (attempt >= maxRetries) throw error;
        lastError = error;
      }
      attempt += 1;
      await new Promise(function(resolve) {
        window.setTimeout(resolve, delay * attempt);
      });
    }
    throw lastError || new Error("Fetch failed " + url);
  }

  function buildVehicleDisplay(vehicle, fallback) {
    if (!vehicle || typeof vehicle !== "object") return fallback || "";
    var year = String(vehicle.year || "").trim();
    var make = String(vehicle.make || "").trim();
    var model = String(vehicle.model || "").trim();
    return [year, make, model].filter(Boolean).join(" ") || (fallback || "");
  }

  window.AuxitoUtils={
    readJson: readJson,
    writeJson: writeJson,
    fetchWithRetry: fetchWithRetry,
    buildVehicleDisplay: buildVehicleDisplay
  };
})(window);
